var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70859 6.79414C8.09922 7.18477 8.09922 7.81914 7.70859 8.20977L1.70859 14.2098C1.31797 14.6004 0.683594 14.6004 0.292969 14.2098C-0.0976562 13.8191 -0.0976562 13.1848 0.292969 12.7941L5.58672 7.50039L0.296094 2.20664C-0.0945313 1.81602 -0.0945313 1.18164 0.296094 0.791016C0.686719 0.400391 1.32109 0.400391 1.71172 0.791016L7.71172 6.79102L7.70859 6.79414Z",
    fill: "#47163F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.b1a5def3201028b5f469929ef3d8a0b8.svg";
export { ForwardRef as ReactComponent };